import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { LayoutWrapperProps } from "@/types";
import headerNavLinks from "@/data/headerNavLinks";

const LayoutWrapper: React.FC<LayoutWrapperProps> = ({ children }) => {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  if (isHome) {
    return <>{children}</>;
  }

  const navLinks = [{ href: "/", title: "Home" }, ...headerNavLinks];

  return (
    // Column layout: main grows to fill leftover height, so the footer sits at the
    // bottom of the viewport on short pages and after the content on long ones.
    <div className="min-h-dvh flex flex-col bg-white">
      {/* Minimal header */}
      <header className="border-b border-black">
        <div className="max-w-4xl mx-auto px-4 sm:px-8 py-4 sm:py-6">
          <nav className="flex items-center justify-between">
            <Link
              to="/"
              className="text-lg sm:text-xl font-bold font-mono hover-invert px-2"
            >
              Ekrem Çetinkaya
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex space-x-1">
              {navLinks.slice(1).map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`text-sm font-mono px-3 py-1 border border-transparent transition-colors duration-200 ${
                    location.pathname === link.href
                      ? "border-black bg-black text-white"
                      : "hover:border-black hover:bg-black hover:text-white"
                  }`}
                >
                  {link.title}
                </Link>
              ))}
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden text-sm font-mono px-3 py-1 border border-black hover:bg-black hover:text-white transition-colors duration-200"
            >
              {isMobileMenuOpen ? "✕" : "☰"}
            </button>
          </nav>

          {/* Mobile Navigation */}
          {isMobileMenuOpen && (
            <div className="md:hidden mt-4 border-t border-black pt-4">
              <div className="flex flex-col space-y-2">
                {navLinks.slice(1).map((link) => (
                  <Link
                    key={link.href}
                    to={link.href}
                    onClick={() => setIsMobileMenuOpen(false)}
                    className={`text-sm font-mono px-3 py-2 border border-transparent transition-colors duration-200 ${
                      location.pathname === link.href
                        ? "border-black bg-black text-white"
                        : "hover:border-black hover:bg-black hover:text-white"
                    }`}
                  >
                    {link.title}
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 w-full max-w-4xl mx-auto px-4 sm:px-8 py-8 sm:py-12">
        {children}
      </main>

      {/* Minimal footer */}
      <footer className="border-t border-black mt-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-8 py-6">
          <div className="flex flex-col sm:flex-row justify-between items-center text-xs font-mono text-gray-500 space-y-2 sm:space-y-0">
            <div>© 2026 Ekrem Çetinkaya</div>
            <div>
              <Link to="/" className="hover:text-black">
                Home
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LayoutWrapper;
